import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule , Router } from '@angular/router';
import { AuthService } from '../Service/app-service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-event-notifications',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, NgxSpinnerModule],
  templateUrl: './event-notifications.component.html',
  styleUrl: './event-notifications.component.css'
})
export class EventNotificationsComponent {
  constructor(private authServie: AuthService, private spinner: NgxSpinnerService, private toast: ToastrService,private router:Router) { }
  showModal = false;
  description: string = '';
  title: string = '';
  notifications: any;
  id: any = null;
  data:any;

  ngOnInit() {
    this.getAllSystemEvents()
  }

  getAllSystemEvents() {
    this.spinner.show();
    this.authServie.getAllSystemEvents().subscribe({
      next: (res: any) => {
        if(res){
          this.notifications = res
          this.spinner.hide();
        }
      },
      error: (error: any) => {
        console.log(error);
        this.spinner.hide()
      }
    })
  }

  editNotification(id: any): void {
    this.showModal = true;
    this.getNotificationById(id)
  }

  getNotificationById(id: any) {
    this.id = id ? id : null;
    if (id) {
      this.authServie.getSystemEventById(id).subscribe({
        next: (res: any) => {
          if (res) {
            this.data = res?.data?.eventName;
            this.description = res?.data?.description;
            this.title = res?.data?.title;
          }
        },
        error: (error: any) => {
          console.log(error);
          this.spinner.hide()
        }
      })
    }
  }

  close() {
    this.showModal = false;
  }

  updateNotification() {
    if (!this.description) {
      this.toast.error('Description is required');
      return;
    }
    if(!this.title){
      this.toast.error('Title is required');
      return;
    }

    let data = { description: this.description , title:this.title }
    this.spinner.show()
    if (this.id) {
      this.authServie.updateSystemEvents(data, this.id).subscribe({
        next: (res: any) => {
          this.spinner.hide()
          this.toast.success(res?.message || 'Description Updated')
          this.getAllSystemEvents()
        },
        error: (error: any) => {
          console.log(error);
          this.spinner.hide()
          this.toast.error(error?.message || 'Something went wrong')
        }
      })
    }
    this.close();
  }

  pauseSytemEvent(id:any){
    if(id){
      this.spinner.show()
      this.authServie.pauseSystemEvent(id).subscribe({
        next:(res:any)=>{
          console.log(res);
          this.spinner.hide()
          this.toast.success(res?.message || 'Notification Paused');
          this.getAllSystemEvents()
        },
        error:(error:any)=>{
          console.log(error);
          this.spinner.hide();
          this.toast.error(error?.message || 'Something went wrong')
        }
      })
    }
  }

  resumeSytemEvent(id:any){
    if(id){
      this.spinner.show()
      this.authServie.resumeSystemEvent(id).subscribe({
        next:(res:any)=>{
          console.log(res);
          this.spinner.hide()
          this.toast.success(res?.message || 'Notification Resumed');
          this.getAllSystemEvents()
        },
        error:(error:any)=>{
          console.log(error);
          this.spinner.hide();
          this.toast.error(error?.message || 'Something went wrong')
        }
      })
    }
  }

  back(){
    this.router.navigate(['/dashboard'],{ state: { fetch: true } })
  }

}
